module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-01-d47db6b0b4988b3fadc02e9b580d1be7.jpg";